<template>
    <!-- 文本域二次封装
        @author: liuguisheng
        @date: 2019-9-13
    -->
  <preview-form-item v-if="isDisplay && showRule!=='render'"
                     :labelText="labelName"
                     :labelWidth="labelWidth"
                     :labelPosition="labelPosition"
                     :textAlign="labelTextPosition"
                     :formType="formType"
                     :variableName="model"
                     :rules="validatorRule"
                     :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-input type='textarea'
                v-model="currentModel"
                :placeholder="placeholder"
                :clearable="isClearable"
                :disabled="isDisabled"
                :autosize="autosize"
                :limit-length="textLength"
                :style="{ width }">
      </el-input>
    </div>
  </preview-form-item>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";


export default {
  mixins: [ mixPreviewItemTemplateChild ],
}

</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemTextarea.vue